const SINGLE_ORDER_SUBJECT_PREFIX = "order:";
const ORDER_PATH_PATTERN = /\/orders\/([^/?#]+)/;

/** The order a stored session is pinned to, if it is pinned to one at all. */
export function sessionOrderId(
  sessionSubject: string | undefined,
): string | undefined {
  return sessionSubject?.startsWith(SINGLE_ORDER_SUBJECT_PREFIX)
    ? sessionSubject.slice(SINGLE_ORDER_SUBJECT_PREFIX.length)
    : undefined;
}

/**
 * Whether a tracking link should replace the stored session. Only single-order
 * sessions can be ruled out here; account-scoped ones are the server's call.
 */
export function shouldExchangeTrackingToken({
  search,
  pathname,
  sessionSubject,
}: {
  search: string;
  pathname: string;
  sessionSubject: string | undefined;
}): boolean {
  if (!new URLSearchParams(search).has("order_tracking_token")) {
    return false;
  }

  const pinnedOrderId = sessionOrderId(sessionSubject);
  if (!pinnedOrderId) {
    return false;
  }

  return pinnedOrderId !== pathname.match(ORDER_PATH_PATTERN)?.[1];
}
